export default __webpack_public_path__ + "static/ala_logo-f4c4e377df14c3509ecf5c3e543c213e.png";